import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from './register.component';
import { InputModule } from 'src/app/common/utilities/input/input/input.module';
import { ButtonFillModule } from 'src/app/common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { SelectModule } from 'src/app/common/utilities/select/select/select.module';
import { CheckBoxModule } from 'src/app/common/utilities/check-box/check-box/check-box.module';
import { ErrorMessageModule } from "../../common/components/error-message/error-message.module";
import { ToastModule } from 'primeng/toast';


@NgModule({
    declarations: [
        RegisterComponent
    ],
    exports: [
        RegisterComponent
    ],
    imports: [
        CommonModule,
        InputModule,
        ButtonFillModule,
        SelectModule,
        CheckBoxModule,
        ErrorMessageModule,
        ToastModule
    ]
})
export class RegisterModule { }
